import { getThemeOptions as getThemeOptionsCommon } from '@lumahealthhq/ui-common';
import { EThemeKey } from '@lumahealthhq/ui-model-types';

export { EThemeKey };

export default function getThemeOptions(themeKey: EThemeKey) {
  // @ts-ignore TODO danielmana adjust type
  return getThemeOptionsCommon(themeKey, { themeKey });
}
